import React, { useState, useEffect } from "react";
import {
    Modal,
    Select,
    MenuItem,
    FormControl,
    FormHelperText,
    Box,
    Checkbox,
    ListItemText,
    Chip,
    Typography,
} from "@mui/material";
import '../../../App.css'; // Import your fonts
import TextField from "../../textField";
import CustomButton from "../../customButton";
import IconButton from "../../iconButton";
import styles from '../styles';
import { handleBuildingCreate } from "../../../functions/buildings";

export default function BuildingForm({
    open,
    handleClose,
    layoutProps,
}) {
    const [buildingName, setBuildingName] = useState('');
    const [selectedOutlets, setSelectedOutlets] = useState([]);
    const [rate, setRate] = useState(0.16);
    const [nameError, setNameError] = useState(false);
    const [outletError, setOutletError] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const onSubmit = async () => {
        // Transforming the array to just contain the outlet ids
        const newOutletsSelected = selectedOutlets.map(obj => obj.id);

        const buildingData = {
            name: buildingName,
            rate: rate,
            orgID: layoutProps.selectedOrgID ? layoutProps.selectedOrgID : layoutProps.orgID,
            outlets: newOutletsSelected,
            buildingID: '',
        };

        const success = await handleBuildingCreate(buildingData, layoutProps, setOutletError, setNameError);
        if (!success && success !== undefined) {
            setLoading(false);
            return;
        } else {
            setBuildingName('');
            setRate(.16);
            setSelectedOutlets([]);
            layoutProps.setRefresh(prev => !prev);
            handleClose();
        };
    };

    const handleClickClose = () => {
        setBuildingName('');
        setRate(.16);
        setSelectedOutlets([]);
        setOutletError(false);
        setNameError(false);
        handleClose();
    };

    return (
        <Modal open={open} onClose={handleClickClose}>
            <Box sx={styles.container}>
                <div style={styles.innerContainer}>
                    <div style={styles.headerContainer}>
                        <div
                            className="titleLarge"
                            style={styles.headerText}
                        >
                            Add a Building
                        </div>
                        <IconButton iconName='cancel-1' tone='dark' size={24} onClick={handleClickClose} />
                    </div>
                    <div style={{height: '80%'}}>
                        <div>
                            <TextField
                                label="Building Name *"
                                placeholder="Enter building name"
                                required
                                value={buildingName}
                                onChange={(value) => {
                                    setNameError(false)
                                    setBuildingName(value)
                                }}
                                size="medium"
                                background='light'
                            />
                            {nameError &&
                                <Typography sx={{
                                    fontSize: "10px",
                                    color: "orange",
                                }}>
                                    Building Name already in use
                                </Typography>
                            }
                        </div>
                        <TextField
                            label="Electricity Rate *"
                            placeholder="Enter the electricity rate in $/kWh"
                            required
                            value={rate}
                            onChange={(event) => {
                                const value = event;
                                setRate(value);
                            }}
                            size="medium"
                            background='light'
                        />
                        <FormControl sx={{ width: "485px", marginTop: '10px' }}>
                            <Select
                                multiple
                                value={selectedOutlets}
                                onChange={(e) => {
                                    setOutletError(false)
                                    setSelectedOutlets(e.target.value)
                                }}
                                required
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', overflow: 'scroll', maxHeight: '300px' }}>
                                        {selected.map((outlet) => (
                                            <Chip key={outlet.id} label={outlet.name} sx={{ margin: '2px' }} />
                                        ))}
                                    </Box>
                                )}
                            >
                                {layoutProps.outlets.map((outlet) => (
                                    <MenuItem key={outlet.id} value={outlet}>
                                        <Checkbox checked={selectedOutlets.includes(outlet)} />
                                        <ListItemText primary={outlet.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText sx={{ color: outletError ? 'orange' : 'inherit' }}>
                                {outletError
                                    ? 'One or more outlets conflicts with another building.'
                                    : 'Select outlets to add to the building'}
                            </FormHelperText>
                        </FormControl>
                    </div>

                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <CustomButton
                            filled={true}
                            label={'Create Building'}
                            onClick={onSubmit}
                            size="medium"
                            disabled={(
                                buildingName !== ''
                                // && selectedOutlets.length !== 0
                            ) ? false : true}
                        />
                    </div>
                </div>
            </Box>
        </Modal>
    );
};